var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content",attrs:{"id":"link-form-login"}},[_c('router-link',{staticClass:"col-6",attrs:{"to":"/esqueci-senha"}},[_vm._v("Alterar senha?")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }